import { FiltersPanel } from '../FiltersPanel';
import React from 'react';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';

export function FiltersPanelSidePanelEntry() {
  const { toolbarFiltersState: state } = useToolbarCollectionContext();
  if (state == null) {
    return null;
  }
  return <FiltersPanel state={state} />;
}
